<template>
  <vue2-gesture :type="'swipeRight'" :call="handleGesture.bind(this, 'swipeRight')">
    <CustomReveal revealId="who-marked-me-favorite-users" :isVisible="whoMarkedMeFavoriteFormVisible" v-on:close-reveal-change-password="closeModal">
      <section class="modal who-marked-me-favorite-users">
        <div class="inner">

          <div class="section-header">
            <i class="back" @click="closeModal"></i>
            <div class="title">{{ trans('who_marked_me_favorite') }}</div>
          </div>

          <vue-custom-scrollbar :settings="scrollBarSettings" class="section-body">
            <div class="step">
              <div class="tab-content-wrapper">
                <div class="tab-content-inner">
                  <div class="tab-content box">
                    <UpgradeToProModal  v-if="!userIsPro"></UpgradeToProModal>

                    <div v-if="userIsPro" class="faces">
                      <div @click="openUserModal(user.id, 1)" class="face" v-for="user in profileWhoMarkedMeFavorite">
                        <div class="img" :style="{'background': `url(${user.photo_small}) no-repeat center / cover`}"></div>
                        <div class="details">
                          <div class="name">
                            <p class="headline">{{ user.headline }}</p>
                            <p class="handle">@{{ user.handle }}</p>
                          </div>
                          <div class="details-star">
                            <i class="green-star"></i>
                          </div>
                        </div>
                      </div>
                    </div>

                    <infinite-loading
                        v-if="userIsPro"
                        ref="infiniteLoadingWhoMarkedMeFavoriteUsers"
                        @infinite="getWhoMarkedMeFavoriteUsers"
                        spinner="bubbles">
                      <span slot="no-results">
                          {{ "Users not exists" }}
                      </span>
                      <span slot="no-more">
                          {{ "No more users" }}
                      </span>
                    </infinite-loading>
                  </div>
                </div>
              </div>
            </div>
          </vue-custom-scrollbar>

        </div>
      </section>
    </CustomReveal>
  </vue2-gesture>
</template>

<script>
import CustomReveal from '@buddy/views/widgets/CustomReveal.vue';
import {mapState} from "vuex";

import discoverModule from "@discover/module/store/type";

// custom scrollbar
import vueCustomScrollbar from 'vue-custom-scrollbar'
import "vue-custom-scrollbar/dist/vueScrollbar.css"
import UpgradeToProModal from "../../../../buddy/views/widgets/UpgradeToProModal.vue";

export default {
  name: "WhoMarkedMeFavoriteUsersReveals",
  mixins: [
      require('@general/lib/mixin').default
  ],
  components: {
    UpgradeToProModal,
    CustomReveal,
    vueCustomScrollbar
  },
  data() {
    return {
        whoMarkedMeFavoriteFormVisible: false,
        profileWhoMarkedMeFavorite: [],
        page: 1,
        limit: 20,
        scrollBarSettings: {
          suppressScrollY: false,
          suppressScrollX: true
        }
    }
  },
  computed: {
    ...mapState({
      userIsPro: 'userIsPro',
    }),
  },
  methods: {
    async getWhoMarkedMeFavoriteUsers(infiniteScroll) {
      let ret_users = [];
      await  axios.get(`/api/user/whomarkedmefavorite?page=${this.page}&limit=${this.limit}`)
          .then((users) => {
           this.profileWhoMarkedMeFavorite.push(...users.data);
            ret_users = users.data;
          })

      if (ret_users.length) {
        infiniteScroll.loaded()
      }

      if (ret_users.length < this.limit) {
        infiniteScroll.complete()
      }

      this.page++;
    },
    reset() {
      if (this.$refs.infiniteLoadingWhoMarkedMeFavoriteUsers) {
        this.$refs.infiniteLoadingWhoMarkedMeFavoriteUsers.stateChanger.reset();
      }
      this.whoMarkedMeFavoriteFormVisible = true;
    },
    closeModal() {
      this.whoMarkedMeFavoriteFormVisible = false;
    },
    handleGesture(str, e) {
      if (str === 'swipeRight') {
        this.closeModal();
      }
    },
  },
  activated() {
    app.$on('show-who-marked-me-favorite', this.reset);
  },
  mounted() {
    app.$on('show-who-marked-me-favorite', this.reset);
  }
}
</script>

<style scoped>

</style>